module.exports = __webpack_public_path__ + "img/ethhub.cbb22c52.png";